import {
  getEditFormInitialValues,
  useGetDefaultAvailabilityRules
} from 'features/event_type_editor'
import {
  getFormatValuesToServerData,
  getShareOverrideAvailability,
  useCreateMultiHostSingleUseLinkMutation,
  useCreateSingleUseLinkMutation
} from 'features/single_use_link_sidebar'

export const useCreateEventTypeSingleUseLink = (eventType) => {
  const defaultAvailabilityRules = useGetDefaultAvailabilityRules()
  const [createSingleUseLink, { isLoading: isCreatingSingleUseLink }] = useCreateSingleUseLinkMutation()
  const [createMultiHostSingleUseLink, { isLoading: isCreatingMultiHostSingleUseLink }] = useCreateMultiHostSingleUseLinkMutation()

  const create = () => {
    if (eventType.isSolo && eventType.isUser) {
      const initialValues = {
        contact: { status: 'none' },
        ...getEditFormInitialValues({ eventType, defaultAvailabilityRules }),
        shareOverrideAvailability: getShareOverrideAvailability({
          eventType,
          shareOverride: null,
          defaultAvailabilityRules
        })
      }

      return createSingleUseLink(getFormatValuesToServerData(eventType, true)(initialValues))
    }

    return createMultiHostSingleUseLink({ eventTypeId: eventType.id, contactUuid: undefined })
  }

  return { create, isLoading: isCreatingSingleUseLink || isCreatingMultiHostSingleUseLink }
}
